// Home Dicts & Funcs

import { 
  mdiGiftOutline,
  mdiSaleOutline,
  mdiHome,
  mdiPoll,
  mdiPlayCircle,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiAccountCircle,
  mdiAccountPlus
} from '@mdi/js';

export const pages = {
  help: {
    title: 'help.title',
    icon: 'help',
    partner: false,
    disabled: false,
    route: { query: { view: 'help' } }
  },
  bonus: {
    title: 'bonus.title',
    icon: 'bonus',
    disabled: false,
    route: { path: '/main/bonus' }
  },
  club: {
    title: 'club.title',
    icon: 'club',
    partner: true,
    disabled: false,
    route: { query: { view: 'help', section: 'benefits' } }
  },
  home: {
    title: 'home.title',
    icon: 'home',
    disabled: false,
    route: { path: '/main/home' }
  },
  payments: {
    title: 'payments.title',
    icon: 'payments',
    disabled: false,
    route: { path: '/main/payments' }
  }
}

export const menu = [
  // ...['home'].map(key => pages[key]),
  {
    title: 'home.menu.buzzer',
    icon: mdiHelpCircleOutline,
    partner: true,
    disabled: false,
    route: { query: { view: 'help', section: 'buzzer' } }
  },
  {
    title: 'home.menu.hours',
    icon: mdiHelpCircleOutline,
    partner: true,
    disabled: false,
    route: { query: { view: 'help', section: 'hours' } }
  },
  {
    title: 'home.menu.rack',
    icon: mdiHelpCircleOutline,
    partner: true,
    disabled: false,
    route: { query: { view: 'help', section: 'rack' } }
  },
  {
    title: 'home.menu.videos',
    icon: mdiPlayCircle,
    partner: true,
    disabled: false,
    route: { query: { view: 'onboarding' } }
  },
  {
    title: 'home.menu.support',
    icon: mdiHelpCircleOutline,
    disabled: false,
    route: { query: { view: 'help' } }
  },
  {
    title: 'home.menu.profile',
    icon: mdiAccountCircle,
    disabled: false,
    route: { query: { view: 'profile' } }
  },
  {
    title: 'home.menu.referral',
    icon: mdiAccountPlus,
    disabled: false,
    route: { query: { view: 'referrals' } }
  },
]

export const reminders = [
  'home.reminders.check_rack_claws',
  'home.reminders.check_buzzer_leds',
  'home.reminders.parking_entrance_height',
  'home.reminders.elevator_caution',
  'home.reminders.loose_wires_caution',
  'home.reminders.always_turn_on_buzzer',
  'home.reminders.no_appointment_without_schedule',
  'home.reminders.review_vs_maintenance',
  'home.reminders.payment_schedule',
  'home.reminders.periodic_review_responsibility',
  'home.reminders.app_only_support',
  'home.reminders.rack_exclusive_use',
  'home.reminders.report_problems_quickly'
]

export default {
  pages,
  reminders
}